var map = {
	"./audio.png": 616,
	"./document.png": 617,
	"./download.png": 618,
	"./file.png": 619,
	"./img_cartoon.png": 620,
	"./img_line_graph.png": 621,
	"./img_real.png": 622,
	"./jttw360.png": 623,
	"./learn.png": 624,
	"./news.png": 625,
	"./science.png": 626,
	"./song_english.png": 627,
	"./song_zh.png": 628,
	"./storybook_video.png": 629,
	"./teach_guide.png": 630,
	"./treehouse.png": 631,
	"./video.png": 632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2509;